import { Optional } from "common/utils/types";
import { PatientKind } from "common/types";
import { StorefrontThemeLayout } from "common/types/clinics";

import { ClientOrderStatus, ClientListOrder } from "client/orders/types";
import { ListSubscription } from "client/subscriptions/types";
import { StorefrontThemeColor, StorefrontThemeImage } from "client/clinics/types";
import { BrowseAllPatientKind } from "client/products/types";

/** Matches dashboard ClientDashboardSummaryKind */
export const DashboardDisplayKind = {
  Subscription: "SUBSCRIPTION",
  Order: "ORDER",
  Cart: "CART",
} as const;
export type DashboardDisplayKind = (typeof DashboardDisplayKind)[keyof typeof DashboardDisplayKind];

interface BaseDashboardSummary {
  kind: Optional<DashboardDisplayKind>;
}

/** Matches dashboard ClientDashboardSummaryView._subscription_summary return value */
export interface SubscriptionDashboardSummary {
  kind: typeof DashboardDisplayKind.Subscription;
  subscriptions: ListSubscription[];
}

/** Matches dashboard ClientDashboardSummaryView._order_summary return value */
export interface OrderDashboardSummary {
  kind: typeof DashboardDisplayKind.Order;
  orders: ClientListOrder[];
  order_status: Optional<ClientOrderStatus>;
  order_has_client_canceled_items: Optional<boolean>;
}

/** Matches dashboard  ClientDashboardSummaryView._cart_summary return value */
export interface CartDashboardSummary {
  kind: typeof DashboardDisplayKind.Cart;
}

/** Matches dashboard ClientDashboardSummaryView._default_summary return value */
export interface NoDashboardSummary {
  kind: null | undefined;
}

/** Matches dashboard ClientDashboardSummarySerializer  */
export type DashboardSummary = BaseDashboardSummary &
  (
    | SubscriptionDashboardSummary
    | OrderDashboardSummary
    | CartDashboardSummary
    | NoDashboardSummary
  );

export type DashboardFilter = {
  species:
    | typeof PatientKind.Canine
    | typeof PatientKind.Feline
    | typeof PatientKind.Equine
    | BrowseAllPatientKind;
};

export type StorefrontThemeConfig = {
  layout: StorefrontThemeLayout;
  color: Optional<StorefrontThemeColor>;
  logo: string | undefined;
  image: Optional<Omit<StorefrontThemeImage, "id">>;
};

export type HomeThemeProps = {
  storefrontThemeConfig: StorefrontThemeConfig;
};
